import {FormSessionApiClient} from "../../../client/formsession/FormSessionApiClient";
import {useDefaultQuery} from "../../../client/useDefaultQuery";
import {getOptionalPrefillStatus, getRequiredPrefillStatus} from "./PrefillStatus";


export function usePrefillRequestsQuery(formSessionId: number | undefined, isAnyRequestInProgress: boolean, formSessionClient: FormSessionApiClient) {
    return useDefaultQuery({
        queryKey: ["form-sessions", formSessionId, "prefill-requests"],
        queryFn: () =>
            formSessionClient.findFormSessionPrefillRequests(formSessionId!)
                    .then((result) => {
                        const requiredPrefillRequests = result.filter(request => request.required === true);
                        const requiredPrefillStatus = getRequiredPrefillStatus(requiredPrefillRequests);

                        const optionalPrefillRequests = result.filter(request => request.required === false);
                        const optionalPrefillStatus = getOptionalPrefillStatus(optionalPrefillRequests);

                        return {
                            requiredPrefillRequests: requiredPrefillRequests,
                            requiredPrefillStatus: requiredPrefillStatus,
                            optionalPrefillRequests: optionalPrefillRequests,
                            optionalPrefillStatus: optionalPrefillStatus,
                        };
                    }),
        enabled: !!formSessionId && isAnyRequestInProgress,
        refetchInterval: 2000,
    });
}
